import service from "@/utils/request";
export function getVipUserListApi(data) {
    return service({
        url: "/vipOrder/getVipUserList",
        method: "get",
        params: data,
    });
}

export function getVipOrderList(data) {
    return service({
        url: "/vipOrder/getVipOrderList",
        method: "get",
        params: data,
    });
}

export function getVipOrderListCount(data) {
    return service({
        url: "/vipOrder/getVipOrderListCount",
        method: "get",
        params: data,
    });
}
